import request from '@/router/axios'

export function getMaterialTagGroupList(params) {
  return request({
    url: '/basic/admin/material-tag-group/page',
    method: 'GET',
    params: params
  })
}

export function deleteMaterialTagGroup(ids) {
    return request({
        url: '/basic/admin/material-tag-group',
        method: 'DELETE',
        params: {
            ids: ids
        }
    })
}

export function addGroupObj (obj) {
    return request({
      url: '/basic/admin/material-tag-group',
      method: 'post',
      data: obj
    })
}

export function putGroupObj (obj) {
    return request({
      url: '/basic/admin/material-tag-group/edit',
      method: 'post',
      data: obj
    })
}